export const fileNameValidator = (file: File | null, regex: RegExp) => {
  if (!file) return false;

  const fileName = file.name.split(".")[0];

  return regex.test(fileName);
};
